import EditorField from "../../Utils/EditorField"
import { careerProfileLabels } from "../../Types/careerProfileLabels"
const MentalHealth = ({ formik }) => {
  return (
    <>
      <div style={{ marginTop: "20px" }}>
        <EditorField
          value={formik.values.mental_1}
          onTextChange={formik.setFieldValue}
          valueName={careerProfileLabels.mentalHealth.mentalHealth_1.value}
          label={careerProfileLabels.mentalHealth.mentalHealth_1.label}
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        {" "}
        <EditorField
          value={formik.values.mental_2}
          valueName={careerProfileLabels.mentalHealth.mentalHealth_2.value}
          onTextChange={formik.setFieldValue}
          label={careerProfileLabels.mentalHealth.mentalHealth_2.label}
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        {" "}
        <EditorField
          value={formik.values.mental_3}
          valueName={careerProfileLabels.mentalHealth.mentalHealth_3.value}
          onTextChange={formik.setFieldValue}
          label={careerProfileLabels.mentalHealth.mentalHealth_3.label}
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        {" "}
        <EditorField
          value={formik.values.mental_4}
          valueName={careerProfileLabels.mentalHealth.mentalHealth_4.value}
          onTextChange={formik.setFieldValue}
          label={careerProfileLabels.mentalHealth.mentalHealth_4.label}
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        <EditorField
          value={formik.values.mental_5}
          valueName={careerProfileLabels.mentalHealth.mentalHealth_5.value}
          onTextChange={formik.setFieldValue}
          label={careerProfileLabels.mentalHealth.mentalHealth_5.label}
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        {" "}
        <EditorField
          value={formik.values.mental_6}
          onTextChange={formik.setFieldValue}
          valueName={careerProfileLabels.mentalHealth.mentalHealth_6.value}
          label={careerProfileLabels.mentalHealth.mentalHealth_6.label}
        />
      </div>
    </>
  )
}
export default MentalHealth
